// Custom date + time range picker.
// Part of the Balances page (components/Balances.jsx). Split out 2026-10-14.

export default function CustomRangeBar({ applyCustomRange, clearCustomTimes, customFrom, customFromTime, customOpen, customTo, customToTime, jumpCycle, loading, setCustomFrom, setCustomFromTime, setCustomOpen, setCustomTo, setCustomToTime, to }) {
  return (
    <>
      {customOpen && (
        <div className="card" style={{ padding: '0.75rem 1rem', marginBottom: '0.75rem', background: '#faf5ff', border: '1px solid #ddd6fe' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', flexWrap: 'wrap' }}>
            <strong style={{ color: '#5b21b6' }}>Custom range:</strong>
            <label className="small">From <input type="date" value={customFrom} onChange={(e) => setCustomFrom(e.target.value)} /></label>
            <input type="time" value={customFromTime} onChange={(e) => setCustomFromTime(e.target.value)} title="From time (00:00 = start of day)" />
            <label className="small">To <input type="date" value={customTo} onChange={(e) => setCustomTo(e.target.value)} /></label>
            <input type="time" value={customToTime} onChange={(e) => setCustomToTime(e.target.value)} title="To time (23:59 = end of day)" />
            <button className="refresh-btn" onClick={applyCustomRange} disabled={loading} style={{ background: '#7c3aed' }}>Apply</button>
            <button className="refresh-btn" onClick={() => { clearCustomTimes(); jumpCycle(); setCustomOpen(false); }} disabled={loading} style={{ background: '#94a3b8' }}>Reset to current cycle</button>
          </div>
          <div className="small" style={{ color: '#6b21a8', marginTop: '0.4rem' }}>
            Time precision applies to tip activity only — QBO invoices are date-only, so any invoice dated on the boundary day counts toward the period regardless of time.
          </div>
        </div>
      )}
    </>
  );
}
